import React, { useState, useEffect } from 'react';
import '../styles/AssignTrainers.css';

const AssignTrainers = ({ group, subjects, onClose }) => {
  const [trainers, setTrainers] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    // Fetch the list of trainers from the backend
    fetch('https://backend-main-4.onrender.com/trainers')
      .then(response => response.json())
      .then(data => setTrainers(data))
      .catch(error => console.error('Error fetching trainers:', error));
  }, []);

  useEffect(() => {
    // Fetch existing assignments for the group
    fetch(`https://backend-main-4.onrender.com/api/assigned-trainers?group=${group}`)
      .then(response => response.json())
      .then(data => {
        const initialAssignments = subjects.map(subject => {
          const existingAssignment = data.find(assignment => assignment.subject === subject);
          return { subject, trainer: existingAssignment ? existingAssignment.trainer : '' };
        });
        setAssignments(initialAssignments);
      })
      .catch(error => console.error('Error fetching assigned trainers:', error));
  }, [group, subjects]);

  const handleAssignmentChange = (index, trainer) => {
    const newAssignments = [...assignments];
    newAssignments[index].trainer = trainer;
    setAssignments(newAssignments);
  };

  const handleSaveAssignments = async () => {
    try {
      const response = await fetch('https://backend-main-4.onrender.com/api/assign-trainers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ group, assignments }),
      });

      if (response.ok) {
        alert('Trainers assigned successfully!');
        onClose();
      } else {
        throw new Error('Failed to assign trainers.');
      }
    } catch (error) {
      setError('Unable to save assignments. Please try again.');
    }
  };

  const handleDeleteAssignment = async (subject) => {
    try {
      const response = await fetch('https://backend-main-4.onrender.com/api/delete-assignment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ group, subject }),
      });

      if (response.ok) {
        setAssignments(assignments.map(assignment => 
          assignment.subject === subject ? { ...assignment, trainer: '' } : assignment
        ));
        alert('Assignment deleted successfully!');
      } else {
        throw new Error('Failed to delete assignment.');
      }
    } catch (error) {
      setError('Unable to delete assignment. Please try again.');
    }
  };

  return (
    <div className="assign-trainers">
      <h3>Assign Trainers for {group} Group</h3>
      {assignments.map((assignment, index) => (
        <div key={index} className="assignment">
          <label>{assignment.subject}</label>
          <select
            value={assignment.trainer}
            onChange={(e) => handleAssignmentChange(index, e.target.value)}
          >
            <option value="">Select Trainer</option>
            {trainers.map(trainer => (
              <option key={trainer._id} value={trainer.name}>{trainer.name}</option>
            ))}
          </select>
          {assignment.trainer && (
            <button onClick={() => handleDeleteAssignment(assignment.subject)} className="delete-button">
              Delete
            </button>
          )}
        </div>
      ))}
      {error && <p className="error-message">{error}</p>}
      <div className="button-group">
        <button onClick={handleSaveAssignments} className="save-button">Save Assignments</button>
        <button onClick={onClose} className="close-button">Close</button>
      </div>
    </div>
  );
};

export default AssignTrainers;
